/**
 * 常规列表的api 之后可以不使用service的方式 直接调取接口比较简单
 * @author limy
 */
import api from '@/services/api'
import {downFile, METHOD, request} from '@/utils/request'

export const dataApi = {
    async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    },
    async selectionStrain() { //品系下拉
        return request(api.clue.CLUE + '/getStrainList', METHOD.GET)
    },

    async selectionActivityType() { //类型下拉
        return request(api.report.REPORTACTIVITYTYPE + '/all', METHOD.GET)
    },

    async customerReportData(params) {
        return request(api.report.REPORT + '/getCustReportData', METHOD.GET, params)
    },
    async customerReportDataNoStrain(params) {
        return request(api.report.REPORT + '/getCustReportDataNoStrain', METHOD.GET, params)
    },
    async clueReportData(params) {//客户线索
        return request(api.report.REPORT + '/getClubReportData', METHOD.GET, params)
    },
    async clueReportDataNoStrain(params) {//客户线索无品系
        return request(api.report.REPORT + '/getClubReportDataNoStrain', METHOD.GET, params)
    },
    async custStructureReportData(params) { //客户结构
        return request(api.report.REPORT + '/getCustStructureReportData', METHOD.GET, params)
    },
    async custStructureReportDataNoStrain(params) { //客户结构无品系
        return request(api.report.REPORT + '/getCustStructureReportDataNoStrain', METHOD.GET, params)
    },
    async bigCustClueReportData(params) { //大客户
        return request(api.report.REPORT + '/getBigCustClueReportData', METHOD.GET, params)
    },
    async bigCustClueReportDataNoStrain(params) { //大客户无品系
        return request(api.report.REPORT + '/getBigCustClueReportDataNoStrain', METHOD.GET, params)
    },
    async custIndustryReportData(params) { //客户行业
        return request(api.report.REPORT + '/keHuHangye', METHOD.GET, params)
    },
    async activityReportData(params) { //活动开展报表
        return request(api.report.REPORTACTIVITY + '/queryActivityCount', METHOD.GET, params)
    },
    async activityListReportData(params) { //活动开展列表
        return request(api.report.REPORTACTIVITY + '/queryActivityCount', METHOD.GET, params)
    },
    async activityEffectReportData(params) { //活动效果报表
        return request(api.report.REPORTACTIVITY + '/queryActivityReferenceList', METHOD.GET, params)
    },
    async clueFailReportData(params) { //活动战败原因分析
        return request(api.report.REPORT + '/zhanBai', METHOD.GET, params)
    },

    async custFollowWithReportData(params) { //客户关注点
        return request(api.report.REPORT + '/keHuGuanZ', METHOD.GET, params)
    },
    async custFollowWithReportDataNoStrain(params) { //客户关注点无品系
        return request(api.report.REPORT + '/keHuGuanZNoStrain', METHOD.GET, params)
    },

    async custknowWayReportData(params) { //客户了解柳汽的方式
        return request(api.report.REPORT + '/keHuLiaoJ', METHOD.GET, params)
    },
    async custknowWayReportDataNoStrain(params) { //客户了解柳汽的方式无品系
        return request(api.report.REPORT + '/keHuLiaoJNoStrain', METHOD.GET, params)
    },

    async custSourceReportData(params) { //客户来源
        return request(api.report.REPORT + '/keHuLaiY', METHOD.GET, params)
    },

    async custSourceReportDataNoStrain(params) { //客户来源无品系
        return request(api.report.REPORT + '/keHuLaiYNoStrain', METHOD.GET, params)
    },
    async exportFile(url, result) {  //导出
        return downFile(url, METHOD.POST, result);
    },
    async popSelect() {
        return request(api.comm.DEPT + '/popSelect', METHOD.GET);
    },
    // async getDownList() {
    //     return request(api.temp.FILE_EXPORT, METHOD.GET);
    // },
    // qf32
    async mainCustReport(params) { //月度新车保客档案信息报表
        return request(api.report.REPORT + '/mainCustReport', METHOD.GET, params)
    },
}

export default {dataApi}
